import apiFetch, { handleApiFetchError } from '@scale/frontend-lib/api-fetch';
import {
  ChatTaskInvokeToolOutput,
  isLongRunningJobOutput,
} from '@scale/shared/chatTaskTools/types';
import { pollChatToolStatusToCompletion } from './chatTaskToolStatusHelpers';

type ChatTaskInvokeToolInput = {
  toolId: string;
  params: Record<string, any>;
  taskMetadata: Record<string, any>;
};

export const invokeChatTaskTool: (
  input: ChatTaskInvokeToolInput,
) => Promise<ChatTaskInvokeToolOutput | undefined> = async input => {
  try {
    const response = await apiFetch(null, `internal/genai/invokeChatTool`, {
      method: 'POST',
      body: input,
    });
    if (isLongRunningJobOutput(response)) {
      const pollResult = await pollChatToolStatusToCompletion(response.jobId, input.toolId);
      return pollResult.result;
    }
    return response;
  } catch (e) {
    handleApiFetchError(e);
    return undefined;
  }
};
